import { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { useEmailConfirmationMutation } from "@sso/apis/registration";
import { CommonPagesContent } from "@sso/components/CommonPagesContent";
import { notificationsMsgs, QueryKeys } from "@sso/constant";
import { CommonPageMessageType } from "@sso/types";

export const EmailConfirmation = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState<CommonPageMessageType>(null);

  const [emailConfirmation, { isLoading }] = useEmailConfirmationMutation();

  const key = searchParams.get(QueryKeys.KEY);
  const secret = searchParams.get(QueryKeys.SECRET);

  useEffect(() => {
    const handleSendRequest = async () => {
      if (!key || !secret) {
        return setMessage({ header: "Sorry", title: notificationsMsgs.WRONG_URL_ADDRESS });
      }
      try {
        await emailConfirmation({ key, secret }).unwrap();
        setMessage({ header: "Thank You", title: notificationsMsgs.EMAIL_CONFIRMATION });
      } catch (error) {
        setMessage({ header: "Oops!", title: notificationsMsgs.DEFAULT_ERROR });
      }
    };
    handleSendRequest();
  }, [emailConfirmation, key, secret]);

  return <CommonPagesContent loading={isLoading} message={message} />;
};
